module.exports = __webpack_public_path__ + "images/pages/lp/user_2_ea9d771ae3b9506b3fb81f4de45496fe.png";